<template>
    <div class="previewContainer" :style="container">
        <div class="previewText" ref="previewText" :style="text">
          <template v-if="isIcon">
            <img v-if="isIcon === 'location'" class="logo-location" src="@/assets/img/icons/Frame-2948.png" alt="">
            <img v-if="isIcon === 'loveLocation'" class="logo-location" src="@/assets/img/icons/Group-mask-wh.png" alt="">
          </template>
          <div style="display:inline-block;">
            <div class="fix-text" v-if="fixText">{{ fixText }}</div>
            <div>{{ inputText1 }}</div>
            <div :style="styleLine2">{{ inputText2 }}</div>
            <div :style="styleLine3">{{ inputText3 }}</div>
          </div>
        </div>
    </div>
</template>

<script>
export default {
  props: ['inputText1', 'inputText2', 'inputText3', 'previewOptions', 'textLeft', 'isIcon', 'fixText'],
  data() {
    return {
      originalFontSize: this.previewOptions.originalFontSize,
      previewHeight: this.previewOptions.previewHeight,
      previewVertOffset: this.previewOptions.previewVertOffset,
      safeWidth: this.previewOptions.safeWidth,
      fontSize: this.previewOptions.fontSize,
      mgLine2: this.previewOptions.mgLine2,
      mgLine3: this.previewOptions.mgLine3,

      container: {
        height: 0,
      },
      text: {
        fontSize: '90px',
        position: 'absolute',
        overflow: 'hidden',
        bottom: 0,
        left: 0,
      },

      previewHeightFirst: this.previewOptions.previewHeight,
    };
  },

  computed: {
    styleLine2() {
      if (this.inputText1 !== '') {
        return `margin-top:${this.mgLine2}px;`;
      }
      return 'margin-top:0;';
    },
    styleLine3() {
      if (this.inputText2 !== '') {
        if (this.inputText1 !== '') {
          return `font-size:${this.fontSize}px;margin-top:${this.mgLine3}px;`;
        }
        return `font-size:${this.fontSize}px;margin-top:${this.mgLine3}px;`;
      } if (this.inputText1 !== '') {
        return `font-size:${this.fontSize}px;margin-top:${this.mgLine3}px;`;
      }
      return `font-size:${this.fontSize}px;margin-top:0;`;
    },
    newHeight() {
      if (this.previewHeightFirst === 120) { return 40; } return 20;
    },
  },

  mounted() {
    requestAnimationFrame(this.render);
  },

  methods: {
    render() {
      this.keepRatio();
      this.scaleText();
      requestAnimationFrame(this.render);
    },

    /**
     * Maintain the aspect ratio of the container
     */
    keepRatio() {
      const { newHeight } = this;// Math.round(this.$el.clientWidth * (9 / 16))
      this.previewHeight = newHeight;
      this.container.height = `${newHeight}px`;
    },

    /**
     * Scale the previewText element to fit the previewContainer
     */
    scaleText() {
      let newFontSize = 0;
      let newTextScale = 1;
      const previewScale = this.previewHeight / this.previewHeightFirst;
      // console.log('previewScale = '+previewScale)

      // If the current text does not fit inside the "safeWidth" bounds of the default container, scale it
      const currentTextWidth = this.textWidth();

      if (currentTextWidth > this.safeWidth) {
        newTextScale = this.safeWidth / currentTextWidth;
      }

      // Scale text to match the actual container size
      newTextScale *= previewScale;

      newFontSize = parseInt(this.text.fontSize, 10) * newTextScale;

      this.updateTextSize(newFontSize, previewScale);
    },

    /**
     * Update the font size and position of the text element in the DOM
     */
    updateTextSize(newFontSize, previewScale) {
      this.$refs.previewText.style['font-size'] = `${newFontSize}px`;
      this.text.fontSize = `${newFontSize}px`;

      const size = this.getElementSizes();
      this.text.left = `${this.textLeft}px`;// (size.container.width - size.text.width) / 2 + 'px'
      this.text.bottom = `${0}px`;/* (size.container.height - size.text.height) / 2 + (this.previewVertOffset * previewScale) + 'px' */
    },

    /**
     * Get the full width of the previewText element
     */
    textWidth() {
      this.text.fontSize = `${this.originalFontSize}px`;
      this.$refs.previewText.style['font-size'] = `${this.originalFontSize}px`;
      this.$refs.previewText.style.overflow = 'auto';

      const textWidth = this.$refs.previewText.scrollWidth;

      this.$refs.previewText.style.overflow = 'hidden';
      return textWidth;
    },

    /**
     * Get the total height and width for the container and text elements
     */
    getElementSizes() {
      return {
        container: {
          width: this.$el.getBoundingClientRect().width,
          height: this.$el.getBoundingClientRect().height,
        },
        text: {
          width: this.$refs.previewText.getBoundingClientRect().width,
          height: this.$refs.previewText.getBoundingClientRect().height,
        },
      };
    },

    htmlEntities(str) {
      return String(str).replace(/&/g, '&').replace(/</g, '<').replace(/>/g, '>')
        .replace(/"/g, '"');
    },

    nl2br(string) {
      return string.replace(/(\r\n|\n\r|\r|\n)/g, '<br>');
    },
  },
};
</script>

<style lang="scss" scoped>
// media query
@import "./../../assets/sass/media-query";

.fix-text{
  font-size: 31px;
  margin-bottom: 10px;

  @include max-mobile{
    font-size: 15px;
    margin-bottom: 4px;
  }
}
</style>
